import React, { useState } from 'react';
import api from '../../services/api';
import { useToast } from '../../context/ToastContext';
import { FiUploadCloud, FiX } from 'react-icons/fi';

const ImageUploader = ({ value, onChange, label = 'Image' }) => {
  const [uploading, setUploading] = useState(false);
  const { showToast } = useToast();

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append('image', file);

    setUploading(true);
    try {
      const res = await api.post('/upload', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      if (res.success) {
        const fullUrl = res.data.url.startsWith('http') ? res.data.url : `https://digitalkit-bc.mpdatahub.com${res.data.url}`;
        onChange(fullUrl);
        showToast('Image uploaded successfully', 'success');
      }
    } catch (err) {
      showToast(err.message || 'Image upload failed', 'error');
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="form-group">
      <label className="form-label">{label}</label>

      {value ? (
        <div style={{ position: 'relative', width: '120px', height: '120px', borderRadius: '12px', overflow: 'hidden', border: '1px solid rgba(255,255,255,0.2)' }}>
          <img src={value} alt="Preview" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
          <button
            type="button"
            onClick={() => onChange('')}
            style={{
              position: 'absolute',
              top: '4px',
              right: '4px',
              background: 'rgba(0,0,0,0.7)',
              color: '#fff',
              borderRadius: '50%',
              width: '24px',
              height: '24px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              cursor: 'pointer'
            }}
          >
            <FiX size={14} />
          </button>
        </div>
      ) : (
        <div
          style={{
            border: '2px dashed rgba(255, 255, 255, 0.15)',
            borderRadius: '12px',
            padding: '1.25rem',
            textAlign: 'center',
            background: 'rgba(255,255,255,0.02)',
            cursor: 'pointer'
          }}
        >
          <input
            type="file"
            accept="image/*"
            onChange={handleFileChange}
            disabled={uploading}
            style={{ display: 'none' }}
            id={`file-input-${label.replace(/\s+/g, '')}`}
          />
          <label htmlFor={`file-input-${label.replace(/\s+/g, '')}`} style={{ cursor: 'pointer' }}>
            <FiUploadCloud size={32} style={{ color: 'var(--primary-500)', marginBottom: '0.5rem' }} />
            <p style={{ fontSize: '0.85rem', color: '#94A3B8' }}>
              {uploading ? 'Uploading Image...' : 'Click to Upload Image (JPG, PNG, WEBP)'}
            </p>
          </label>
        </div>
      )}

      <input
        type="text"
        className="form-control"
        placeholder="Or paste image URL directly..."
        value={value || ''}
        onChange={(e) => onChange(e.target.value)}
        style={{ marginTop: '0.5rem', fontSize: '0.85rem' }}
      />
    </div>
  );
};

export default ImageUploader;
